export const sideBarMenus = [
  {
    menu_id: 1,
    menu_name: "Default",
    menu_code: "default",
    menu_icon: "NULL",
    sub_menu: [
      {
        menu_id: 110,
        menu_name: "Summary",
        menu_code: "summary",
        menu_icon: "User Group",
        sub_menu: [
          {
            menu_id: 111,
            menu_name: "Engaged HCP's",
            menu_code: "emsl/summary/engaged-hcps",
            menu_icon: "user-star",
            sub_menu: [],
          },
          {
            menu_id: 112,
            menu_name: "Consented Leads",
            menu_code: "emsl/summary/consented-leads",
            sub_active_path: "/emsl/summary/consented_leads",
            menu_icon: "funnel",
            sub_menu: [],
          },
          {
            menu_id: 113,
            menu_name: "Interactions",
            menu_code: "emsl/summary/interactions",
            sub_active_path: "/emsl/summary/interactions",
            menu_icon: "search-demo",
            sub_menu: [],
          },
          {
            menu_id: 114,
            menu_name: "Prescribers",
            menu_code: "emsl/summary/prescribers",
            menu_icon: "target",
            sub_menu: [],
          },
        ],
      },
    ],
  },
];
